module.exports = __webpack_public_path__ + "static/img/p2.796b946.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p2.png
// module id = /C5v
// module chunks = 1